// src/components/NotFound.tsx
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '380px', textAlign: 'center', padding: '2rem' }}>
      <p style={{ fontSize: '96px', fontWeight: 500, opacity: 0.08, lineHeight: 1, marginBottom: '-1.5rem', fontFamily: 'monospace' }}>404</p>
      <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--color-background-secondary)', border: '0.5px solid var(--color-border-tertiary)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }}>
        <i className="fas fa-exclamation" style={{ color: 'var(--color-text-secondary)' }}></i>
      </div>
      <p style={{ fontSize: '20px', fontWeight: 500, margin: '0 0 0.5rem' }}>Página no encontrada</p>
      <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', margin: '0 0 2rem', maxWidth: 300 }}>
        La página que buscas no existe o no tienes permisos para acceder a ella.
      </p>
      <button onClick={() => navigate('/main/recintos')} style={{ padding: '8px 20px', borderRadius: 8, border: '0.5px solid', cursor: 'pointer' }}>
        ← Volver al inicio
      </button>
    </div>
  );
};

export default NotFound;